import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class CatalogEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  id_user?: Optional<string> = Optional.empty();
  userGuid?: Optional<string> = Optional.empty();
}

export class CatalogEventCriteriaModelQuery {
  query = '';

  constructor(catalogEventCriteriaModel: CatalogEventQueryCriteriaClass) {

    if (!catalogEventCriteriaModel) {
      return;
    }

    this.query += catalogEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += catalogEventCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');
    this.query += catalogEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += catalogEventCriteriaModel.id_user.filter(x => x !== '').map(x => '&id_user=' + x).orElse('');
    this.query += catalogEventCriteriaModel.userGuid.filter(x => x !== '').map(x => '&userGuid=' + x).orElse('');

    this.query += '&status=' + catalogEventCriteriaModel.status;
    this.query += '&orderBy=' + catalogEventCriteriaModel.orderBy;
    this.query += '&order=' + catalogEventCriteriaModel.order;
    this.query += '&offset=' + catalogEventCriteriaModel.offset + '&limit=' + catalogEventCriteriaModel.limit;
  }
}
